import { AxiosResponse } from "axios";
import { takeLatest, call, put } from "redux-saga/effects";
import {
    getOrganizations,
    showOrganization,
} from "../../services/organization/organization.service";
import {
    getAdminOrganizations,
    getAdminOrganizationsSuccess,
    getAdminOrganizationsFailure,
    getAdminOrganization,
    getAdminOrganizationFailure,
    getAdminOrganizationSuccess,
} from "../reducer/admin-organization";
import {
    GetAdminOrganizationsActionPayload,
    GetAdminOrganizationActionPayload,
} from "../types/admin-organization";
import { IOrganization, IOrganizationResponse } from "../../interfaces/organization.interface";

// Upper bound on a fetchAll walk so a bad pages_total cannot loop unbounded
const MAX_FETCH_ALL_PAGES = 40;

function* getOrganizationsSaga(actions: GetAdminOrganizationsActionPayload) {
    try {
        const { fetchAll, ...query } = actions.payload;
        const { data }: AxiosResponse<IOrganizationResponse> = yield call(
            getOrganizations,
            query
        );
        if (!fetchAll) {
            yield put(getAdminOrganizationsSuccess(data));
            return;
        }

        // Sequential on purpose: httpClient aborts an in-flight request to the same URL
        let rows: IOrganization[] = [...(data?.data ?? [])];
        const lastPage = Math.min(data?.meta?.pages_total ?? 1, MAX_FETCH_ALL_PAGES);
        for (let page = query.page + 1; page <= lastPage; page++) {
            const { data: next }: AxiosResponse<IOrganizationResponse> = yield call(
                getOrganizations,
                { ...query, page }
            );
            rows = rows.concat(next?.data ?? []);
        }
        yield put(getAdminOrganizationsSuccess({ ...data, data: rows }));
    } catch (error: any) {
        yield put(getAdminOrganizationsFailure(error));
    }
}

function* getOrganizationSaga(actions: GetAdminOrganizationActionPayload) {
    try {
        const { data }: AxiosResponse = yield call(
            showOrganization,
            actions.payload
        );
        yield put(getAdminOrganizationSuccess(data));
    } catch (error: any) {
        yield put(getAdminOrganizationFailure(error));
    }
}

export function* rootSaga() {
    yield takeLatest(getAdminOrganizations.type, getOrganizationsSaga);
    yield takeLatest(getAdminOrganization.type, getOrganizationSaga);
}
